import React from 'react'
import PropTypes from 'prop-types'
import { ChevronIcon } from 'components/Icons'
import trackGTM from 'utils/trackGTM'
import { useTheme } from 'styled-components'
import {
  OpenHoursWrapper,
  OpenHoursContent,
  VirtualBoutiqueOnlyContent,
  OpenHoursLabel,
  Divider,
} from './OpenHours.style'

const OpenHours = ({
  background,
  statusLabel,
  hoursLabel,
  onClick,
  virtualBoutiqueOnly,
  virtualBoutiqueOnlyText,
  showIcon,
}) => {
  const onClickHandler = () => {
    onClick()
    trackGTM(
      'accordion interaction',
      'accordion interaction',
      'opening hours',
      'village'
    )
  }
  const { colors } = useTheme()

  return (
    <OpenHoursWrapper
      id="openinghours"
      background={background}
      onClick={virtualBoutiqueOnly ? null : onClickHandler}>
      {virtualBoutiqueOnly ? (
        <VirtualBoutiqueOnlyContent>
          <OpenHoursLabel background={background}>
            {virtualBoutiqueOnlyText}
          </OpenHoursLabel>
        </VirtualBoutiqueOnlyContent>
      ) : (
        <OpenHoursContent>
          <div>
            <OpenHoursLabel bold background={background}>
              {statusLabel}
            </OpenHoursLabel>
            <Divider background={background}>&#11049;</Divider>
            <OpenHoursLabel background={background}>
              {hoursLabel}
            </OpenHoursLabel>
          </div>
          {showIcon && (
            <ChevronIcon
              width={[15]}
              height={[15]}
              color={background === 'Grey' ? colors.dark : colors.darkToGreen}
              transform="rotate(180deg)"
            />
          )}
        </OpenHoursContent>
      )}
    </OpenHoursWrapper>
  )
}

OpenHours.propTypes = {
  background: PropTypes.string,
  statusLabel: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  virtualBoutiqueOnly: PropTypes.bool,
  virtualBoutiqueOnlyText: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
}
OpenHours.defaultProps = {
  background: 'White',
  virtualBoutiqueOnly: false,
  showIcon: true,
}
export default OpenHours
